import { createApp, h } from "vue";
import i18nwithInDomMessages from "./i18n.withInDomMessages";
import { createI18nFor } from "./i18n.dynamic";
import App from "./App.vue";
import config from "./config";
import Vue3Sanitize from "vue-3-sanitize";

const app = createApp({ render: () => h(App, config) });

const urlLang = new URLSearchParams(window.location.search).get("lang") || "";
const configLang = (config as any).locale || "";
const injectedLang = (window as any)["contentLocale"] || ""; // still two-letter per your rule
const requestedLocale = (urlLang || configLang || injectedLang || "en").toLowerCase();

if ((window as any)["contentDictionary"] && injectedLang) {
  app.use(i18nwithInDomMessages);
  app.use(Vue3Sanitize, { allowedTags: ["strong"] });
  app.mount("#sm-resource-index");
} else {
  // Otherwise: load ./locales/<xx>.json dynamically
  createI18nFor(requestedLocale).then((i18n) => {
    app.use(i18n);
    app.use(Vue3Sanitize, { allowedTags: ["strong"] });
    app.mount("#sm-resource-index");
  });
}
